import { useMenuContext } from './context.js';
import { type ReactNode } from 'react';

export const MenuReference = ({
  children,
  className,
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) => {
  const { referenceElement } = useMenuContext();

  return (
    <div
      className={className}
      ref={referenceElement}
      style={{ lineHeight: 0 }}
    >
      {children}
    </div>
  );
};
